<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToInheemsStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="clickable" id="reset_btn_top" @click="resetGameDialog()" src="./../../assets/images/Asset 45_.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/inheems/Asset 1.png" alt="">
    <img draggable="false" id="game_drawer" src="./../../assets/images/inheems/Asset 5.png">

    <span v-if="render == 1">
      <p draggable="true" v-on:dragstart="drag($event)" class="word clickable" id="matapi_text">Matapi</p>
      <p draggable="true" v-on:dragstart="drag($event)" class="word clickable" id="mutete_text">Mutete</p>
      <p draggable="true" v-on:dragstart="drag($event)" class="word clickable" id="kuru_kuru_text">Kuru Kuru</p>
      <p draggable="true" v-on:dragstart="drag($event)" class="word clickable" id="manari_text">Manari</p>
    </span>

    <img draggable="false" id="inheems_item_1" src="./../../assets/images/inheems/Asset 11.png" alt="">
    <img draggable="false" id="inheems_item_2" src="./../../assets/images/inheems/Asset 10.png" alt="">
    <img draggable="false" id="inheems_item_3" src="./../../assets/images/inheems/Asset 9.png" alt="">
    <img draggable="false" id="inheems_item_4" src="./../../assets/images/inheems/Asset 8.png" alt="">

    <div class="box" id="manari_box" v-on:drop="drop($event)" v-on:dragover="allowDrop($event, 'manari_box')"></div> <!-- 1 -->
    <div class="box" id="matapi_box" v-on:drop="drop($event)" v-on:dragover="allowDrop($event, 'matapi_box')"></div> <!-- 2 -->
    <div class="box" id="mutete_box" v-on:drop="drop($event)" v-on:dragover="allowDrop($event, 'mutete_box')"></div> <!-- 3 -->
    <div class="box" id="kuru_kuru_box" v-on:drop="drop($event)" v-on:dragover="allowDrop($event, 'kuru_kuru_box')"></div> <!-- 4 -->

  </span>
</template>

<script>
import swal from 'sweetalert2'

export default {
  name: "InheemsGame",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {
      items_dropped: [],
      dropped_text: '',
      dropped_box: '',
      
      render: 1
    };
  },

  methods: {
    resetGameDialog() {
      var that = this
      new swal({
          allowEscapeKey: false,
          allowOutsideClick: false,
          title: "",
          html: `<p class='swal_html'>Wil je het opnieuw?</p>`,
          type: "success",
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: 'Nee, ga terug',
          confirmButtonColor: "#9BCB3C",
          confirmButtonText: "Ja",
        }).then(function (confirm) {
          if ( confirm.isConfirmed ) {
            that.resetGame();
          } else {
            that.goToInheemsStart();
          }
        });
    },

    goToInheemsStart() {
      this.$router.push('/inheems/start');
    },

    allowDrop(event, box_type) {
      this.dropped_box = box_type;
      event.preventDefault();
    },

    drag(event) {
      event.dataTransfer.setData("text", event.target.id);
    },

    drop(event, intended_drop) {
      event.preventDefault();
      var data = event.dataTransfer.getData("text");

      this.dropped_text = data;

      if (
        this.dropped_box == 'manari_box' && this.dropped_text == 'manari_text' ||
        this.dropped_box == 'matapi_box' && this.dropped_text == 'matapi_text' ||
        this.dropped_box == 'mutete_box' && this.dropped_text == 'mutete_text' ||
        this.dropped_box == 'kuru_kuru_box' && this.dropped_text == 'kuru_kuru_text'
      ) {
        event.target.appendChild(document.getElementById(data));
        this.items_dropped.push(data);
      }

    },

    resetGame() {
      this.items_dropped = []
      this.render = 0

      $('#manari_text').remove()
      $('#matapi_text').remove()
      $('#mutete_text').remove()
      $('#kuru_kuru_text').remove()

      let that = this
      setTimeout(function() {
        that.render = 1
      }, 50)
    },

    clearData() {
      this.dropped_text = ''
      this.dropped_box = ''
    }
  },

  computed: {},
  watch: {
    items_dropped(count) {
      console.log(count.length);
      if ( count.length == 4 ) {
        this.resetGameDialog()
      }
    }
  }
};
</script>

<style>
  .box {
    position: absolute;
    margin-top: 40%;
    height: 10%;
    border: 2px solid #000;
  }
  
  /* 1 */
  #kuru_kuru_box {
    left: 22%;
    width: 12%;
  }

  /* 2 */
  #mutete_box {
    left: 36.3%;
    width: 12%;
  }

  /* 3 */
  #matapi_box {
    left: 50%;
    width: 12%;
  }

  /* 4 */
  #manari_box {
    left: 64.5%;
    width: 12%;
  }

  .word {
    font-family: 'LuckiestGuy';
    position: absolute;
    color: #422818;
    font-size: 3vw;
    text-align: center;
    filter: drop-shadow(5px 2px 7px #3d3d3d);
    -webkit-filter: drop-shadow(5px 2px 7px #3d3d3d);
  }

  /**
  After word has been put into box, reset left %
  */
  .box > #matapi_text {
    left: 0%;
    margin-top: 0%;
  }
  .box > #mutete_text {
    left: 0%;
    margin-top: 0%;
  }
  .box > #kuru_kuru_text {
    left: 0%;
    margin-top: 0%;
  }
  .box > #manari_text {
    left: 0%;
    margin-top: 0%;
  }

  #matapi_text {
    margin-top: 15%;
    width: 50%;
    left: 25%;
  }

  #mutete_text {
    margin-top: 18%;
    width: 50%;
    left: 25%;
  }

  #kuru_kuru_text {
    margin-top: 21%;
    width: 50%;
    left: 25%;
  }

  #manari_text {
    margin-top: 24%;
    width: 50%;
    left: 25%;
  }

  #inheems_game_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 26%;
    width: 50%;
    left: 25%;
    color: #422818;
    font-size: 2.5vw;
    text-align: center;
  }
  .tembe_card {
    position: absolute;
    width: 25%;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
  }
  #tembe_card_1 {
    margin-top: 10%;
    left: 25%;
  }
  #inheems_gamestart_btn {
    position: absolute;
    margin-top: 37%;
    left: 40%;
    width: 20%;
  }
  #inheems_item_1 {
    position: absolute;
    margin-top: 29%;
    left: 23.5%;
    width: 10%;
  }
  #inheems_item_2 {
    position: absolute;
    margin-top: 27%;
    left: 38%;
    width: 10%;
  }
  #inheems_item_3 {
    position: absolute;
    margin-top: 29%;
    left: 51%;
    width: 10%;
  }
  #inheems_item_4 {
    position: absolute;
    margin-top: 29.5%;
    left: 66%;
    width: 10%;
  }
</style>


